var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('item-detail-component',{attrs:{"item-type":'premiumMarketDetail',"item-key":_vm.itemKey}}),_c('auction-history-modal'),_c('commission-info-modal'),_c('share-modal'),_c('gift-item-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }